import React, { Component, Fragment } from 'react';
import { Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';
import { StatusEnum } from 'Common/Constants/Enumeration/StatusEnum';
import DelayedFetchGrid from 'Components/grids/DelayedFetchGrid';

class StudentLookupGrid extends Component {
  static propTypes = {
    students: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
  };

  state = {
    tableState: {},
  };

  componentDidUpdate(prevProps) {
    const { showWithdrawn } = this.props;
    const { tableState } = this.state;

    if (prevProps.showWithdrawn !== showWithdrawn) {
      this.props.onFetchData(tableState, showWithdrawn);
    }
  }

  columns = [
    {
      Header: 'Student #',
      accessor: Fields.Id,
      maxWidth: 150,
    },
    {
      Header: 'Last Name',
      accessor: Fields.LastName,
    },
    {
      Header: 'First Name',
      accessor: Fields.FirstName,
    },
    {
      Header: 'MI',
      id: Fields.MiddleName,
      Cell: ({ original }) => {
        return (
          <div className={'text-center'}>
            {original[Fields.MiddleName]
              ? original[Fields.MiddleName].substring(0, 1).toUpperCase()
              : ''}
          </div>
        );
      },
      filterable: true,
      sortable: true,
      maxWidth: 45,
    },
    {
      Header: 'DOB',
      accessor: Fields.BirthDate,
      maxWidth: 100,
    },
    {
      Header: 'Grade',
      accessor: Fields.GradeId,
      maxWidth: 75,
    },
    {
      Header: 'Site',
      accessor: Fields.SiteId,
      maxWidth: 100,
    },
    {
      Header: 'Parent/Guardian',
      id: Fields.HHLastName,
      Cell: ({ original }) => {
        return original[Fields.HHLastName] ? (
          <Fragment>
            {original[Fields.HHLastName]}, {original[Fields.HHFirstName]}
          </Fragment>
        ) : null;
      },
    },
    {
      Header: '',
      id: 'select',
      Cell: ({ original: stu }) => {
        const disabled = this.props.disabledStudents.includes(stu[Fields.Id]);

        return (
          <div className={'grid--button-container'}>
            <Button
              compact
              secondary
              content={
                disabled ? this.props.buttonTextDisabled : this.props.buttonText
              }
              disabled={disabled}
              onClick={this.onSelect(stu)}
              size={'mini'}
            />
          </div>
        );
      },
      maxWidth: 75,
      filterable: false,
      sortable: false,
    },
  ];

  getTrProps = (state, rowInfo, column) => {
    return {
      style: {
        color:
          rowInfo &&
          rowInfo.original &&
          rowInfo.original.StatusCurrent === StatusEnum.Withdrawn
            ? 'red'
            : '',
      },
    };
  };

  onSelect = student => () => this.props.onSelect(student);

  onFetchData = tableState => {
    this.setState({ tableState }, () => {
      this.props.onFetchData(tableState, this.props.showWithdrawn);
    });
  };

  render() {
    const { students, loading, totalPages, defaultFilter } = this.props;
    return (
      <DelayedFetchGrid
        showClearFiltersButton
        columns={this.columns}
        data={students}
        defaultPageSize={10}
        fetchData={this.onFetchData}
        getTrProps={this.getTrProps}
        loading={loading}
        pages={totalPages}
        showPageSizeOptions={false}
        defaultFilter={defaultFilter}
      />
    );
  }
}

StudentLookupGrid.defaultProps = {
  buttonText: 'Select',
  buttonTextDisabled: 'Selected',
  showWithdrawn: false,
  disabledStudents: [],
};

export { StudentLookupGrid };



// WEBPACK FOOTER //
// ./src/common/Components/StudentLookupGrid/StudentLookupGrid.js